import { render, staticRenderFns } from "./goodProductDetail.vue?vue&type=template&id=521f7496&scoped=true"
import script from "./goodProductDetail.vue?vue&type=script&lang=js"
export * from "./goodProductDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=521f7496&prod&scoped=true&lang=css&external"
import style1 from "./goodProductDetail.vue?vue&type=style&index=1&id=521f7496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f7496",
  null
  
)

export default component.exports